// Workout names and kinds. Walks, runs, rides and hikes are movement and are listed with
// Trace's (Activity → Walks, runs & rides); everything else (lifting, yoga…) is a workout.

export type MoveKind = 'walk' | 'run' | 'ride' | 'hike';

const MOVES: [RegExp, MoveKind][] = [
  [/^(walk|walking)$/, 'walk'],
  [/^(run|running|trailrun|trail running|virtualrun|treadmill)$/, 'run'],
  [/^(ride|cycling|bike|biking|ebikeride|virtualride|mountainbikeride|gravelride)$/, 'ride'],
  [/^(hike|hiking)$/, 'hike'],
];

/** 'walk' for "Walk", "walking"…; null for a workout that isn't getting somewhere. */
export function moveKind(type: string): MoveKind | null {
  const t = type
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
  for (const [re, k] of MOVES) if (re.test(t)) return k;
  return null;
}

const OURA_NAMES: Record<string, string> = {
  walking: 'Walk',
  running: 'Run',
  cycling: 'Ride',
  hiking: 'Hike',
  strengthTraining: 'Strength training',
  weightLifting: 'Strength training',
  hiit: 'HIIT',
  yoga: 'Yoga',
  pilates: 'Pilates',
  swimming: 'Swim',
};

/** Oura's "strengthTraining" → "Strength training". */
export function ouraWorkoutType(activity: string): string {
  const known = OURA_NAMES[activity];
  if (known) return known;
  const words = activity
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** The choices when logging one by hand (anything else: Other + a name). */
export const WORKOUT_TYPES = [
  'Strength training',
  'Run',
  'Walk',
  'Ride',
  'Hike',
  'Yoga',
  'HIIT',
  'Swim',
  'Sports',
] as const;

/** Strava's "WeightTraining" → "Weight training"; names already in words stay as they are. */
export function workoutName(type: string): string {
  if (!/[a-z][A-Z]/.test(type) || /\s/.test(type)) return type;
  const words = type.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
